// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iG","advertCardHeader__actions":"c-a_iH","advertCardHeader__bottomLabel":"c-a_iJ"};